import React, { Component } from 'react';


export default class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
            menus: null,
            targetli: null,
            showmenu: false,
            showsubmenu:false,
            targesubmenu:null,
            showobj: { display: 'block'},
            notshowobj: { display: 'none'},
            isModalOpen: false,
            companylogo: false,
            contactbtntext: null,
            contactbtnlink: null,
            isSticky: false,    
                    
        }    
        this.headerRef = React.createRef();           
                    
    }

    openCloseModal = (event) => {
        event.preventDefault()
        this.setState({
            isModalOpen: !this.state.isModalOpen
        })
      };    
    
    showHide = (e) => {
        this.setState({
            showmenu: !this.state.showmenu,            
            targetli: e.target.id 
        })                
    }

    handleScroll = () => {
        const offset = window.scrollY;
        const headerHeight = this.headerRef.current.getBoundingClientRect().height;
    
        if (offset > headerHeight) {
          this.setState({ isSticky: true });
        } else {
          this.setState({ isSticky: false });
        }
      }

    async componentDidMount() {        
       await this.getData(); 
       await this.getCompanyData();   
       window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
      }
    async getData() {

       await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/menus/v1/menus/header-menu`).then((response) => {
            response.json().then((result) => {
                this.setState({ menus: result.items })                
            })
        })    

    }

    async getCompanyData(){
        await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/custom/v1/company-info`).then((response) => {
            response.json().then((result) => {                       
                this.setState({ 
                    companylogo: result.company_logo,               
                    contactbtntext: result.header_contact_button_text,
                    contactbtnlink: result.header_contact_button_link
                 })           
              
            })
        })
    }

    render() {
        return (
            <>            
                {/* // Header Start */}
               
                <div id="header" ref={this.headerRef}  className={this.state.isSticky ? 'section header-section sticky' : 'section header-section'}>

                    <div className="container">

                        {/* <!-- Header Wrap Start  --> */}
                        <div className="header-wrap">

                            <div className="header-logo">
                                <a href="/"><img src={`${process.env.PUBLIC_URL}/images/k-logo-color.png`} alt="Logo" /></a>
                            </div>

                            <div className="header-menu d-none d-lg-block">

                                {

                                    this.state.menus ?
                                        <ul className="main-menu">
                                            {
                                                this.state.menus.map((item, i) =>

                                                    <li key={i}>
                                                         {
                                                            item.slug === "home-page" || item.slug === undefined?
                                                            <a href="/">{item.title}</a>:
                                                            <a href={"/"+item.slug}>{item.title}</a>
                                                        }
                                                        
                                                        {
                                                            item.child_items ?
                                                                <ul className="sub-menu">
                                                                    {
                                                                        item.child_items.map((citem, c) =>
                                                                            <li key={c}><a href={"/"+citem.slug}>{citem.title}</a>
                                                                                {
                                                                                    citem.child_items ?
                                                                                        <ul className="sub-last-menu">
                                                                                            {
                                                                                                citem.child_items.map((ccitem, d) =>
                                                                                                    <li key={d}><a href={"/"+ccitem.slug}>{ccitem.title}</a></li>
                                                                                                )
                                                                                            }
                                                                                        </ul>
                                                                                        : null
                                                                                }
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>
                                                                : null
                                                        }

                                                    </li>
                                                )
                                            }
                                        </ul> :
                                        <div>Please wait...</div>
                                }


                            </div>

                            {/* <!-- Header Meta Start --> */}
                            <div className="header-meta">
                                {/* <!-- Header Search Start --> */}
                                {/* <div className="header-search">
                                    <a className="search-btn" href="/#" onClick={this.openCloseModal}><i className="flaticon-loupe"></i></a>                                  
                                    {
                                        this.state.isModalOpen?
                                        <div className="search-wrap">                                        
                                            <div className="search-inner">
                                                <i id="search-close" className="flaticon-close search-close" onClick={this.openCloseModal}></i>                                            
                                                    <div className="search-cell">
                                                        <form action="#">
                                                            <div className="search-field-holder">
                                                                <input className="main-search-input" type="search" placeholder="Search Your Keyword..." />
                                                            </div>
                                                        </form>
                                                    </div>
                                            </div>
                                        </div>
                                        :
                                        null
                                    }                                    
                                </div> */}
                                
                                {/* Header Search End */}
                                <div className="header-search">
                                    <a className="search-btn" href="tel:0917992599257"><i className="flaticon-phone-call"></i></a>
                                </div>

                                <div className="header-btn d-none d-xl-block">
                                    <a className="btn" href={this.state.contactbtnlink}>{this.state.contactbtntext}</a>
                                </div>
                                {/* <!-- Header Toggle Start --> */}
                                <div className="header-toggle d-lg-none">
                                    <button data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                                {/* <!-- Header Toggle End --> */}
                            </div>
                            {/* <!-- Header Meta End  --> */}

                        </div>
                        {/* <!-- Header Wrap End  --> */}

                    </div>
                </div>                

                {/* <!-- Offcanvas Start--> */}
                <div className="offcanvas offcanvas-start" id="offcanvasExample">
                 
                    <div className="offcanvas-header">
                        {/* <!-- Offcanvas Logo Start --> */}
                        <div className="offcanvas-logo">
                            <a href="/"><img src={`${process.env.PUBLIC_URL}/images/k-logo-w.png`} alt="" /></a>
                        </div>
                        {/* <!-- Offcanvas Logo End --> */}
                        <button type="button" className="close-btn" data-bs-dismiss="offcanvas"><i className="flaticon-close"></i></button>
                    </div>

                    {/* <!-- Offcanvas Body Start --> */}
                    <div className="offcanvas-body">
                        <div className="offcanvas-menu">

                            {

                                this.state.menus ?
                                    <ul className="main-menu">
                                        { 
                                            
                                            this.state.menus.map((item, oi) =>                                                
                                                

                                                <li key={"a"+oi}>
                                                    {
                                                        item.slug === "home-page"  || item.slug === undefined?
                                                        <a href="/">{item.title}</a>:
                                                        <a href={"/"+item.slug}>{item.title}</a>
                                                    }
                                                    {
                                                        
                                                        item.child_items ?
                                                            this.state.showmenu === false?
                                                                <span  className="menu-expand" onClick={this.showHide}><img id={oi} src={`${process.env.PUBLIC_URL}/images/plus-icon.png`} alt="" /></span>
                                                                :
                                                                <span  className="menu-expand" onClick={this.showHide}><img id={oi} src={`${process.env.PUBLIC_URL}/images/minus-icon.png`} alt="" /></span>
                                                            :
                                                            null
                                                    }
                                                    {         
                                                       
                                                        item.child_items ?  
                                                                <ul className="sub-menu" style={(Number(this.state.targetli) === oi && this.state.showmenu === true) ? this.state.showobj : this.state.notshowobj }>
                                                                    {         
                                                                        
                                                                        item.child_items.map((citem, oc) =>
                                                                            
                                                                            <li key={"b"+oc}><a href={"/"+citem.slug} key={"d"+oc} >{citem.title}</a>
                                                                                {
                                                                                    citem.child_items ?
                                                                                        <ul className="sub-last-menu">
                                                                                            {
                                                                                                citem.child_items.map((ccitem, od) =>
                                                                                                    <li key={"c"+od}><a href={"/"+ccitem.slug} key={"c"+od}>{ccitem.title}</a></li>
                                                                                                )
                                                                                            }
                                                                                        </ul>
                                                                                        : null
                                                                                }
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>                                                               
                                                            : null
                                                    }

                                                </li>
                                            )
                                        }
                                    </ul> :
                                    <div>Please wait...</div>
                            }

                        </div>
                    </div>
                    {/* <!-- Offcanvas Body End --> */}
                </div>
                {/* <!-- Offcanvas End -->  */}
            </>
            // {/* Header End */}
        )
    }
}


